import { render, staticRenderFns } from "./foods.vue?vue&type=template&id=66c31bad"
import script from "./foods.vue?vue&type=script&lang=js"
export * from "./foods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports